import { render, staticRenderFns } from "./KModal.vue?vue&type=template&id=6779362c&scoped=true"
import script from "./KModal.vue?vue&type=script&lang=js"
export * from "./KModal.vue?vue&type=script&lang=js"
import style0 from "./KModal.vue?vue&type=style&index=0&id=6779362c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6779362c",
  null
  
)

export default component.exports